import { useEffect, useState } from 'react';
import WidgetService from '../services/widget';

function useWidget({ type }) {
  const [isWidgetLoading, setIsWidgetLoading] = useState(false);
  const [widget, setWidget] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setIsWidgetLoading(true);

    WidgetService.getWidgetByType(type).then((response) => {
      if (cancelled) return;
      setWidget(response || null);
      setIsWidgetLoading(false);
    });

    return () => {
      cancelled = true;
    };
  }, [type]);

  return { isWidgetLoading, widget }
}

export default useWidget;
